import _classCallCheck from "/Users/yojona/Proyectos/sac/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yojona/Proyectos/sac/app/node_modules/@babel/runtime/helpers/esm/createClass";

var Mafuba =
/*#__PURE__*/
function () {
  function Mafuba(object) {
    _classCallCheck(this, Mafuba);

    if (Array.isArray(object)) this.error('Mafuba constructor expects an object.');

    if (!object || typeof object !== 'object') {
      this.error('Mafuba constructor expects ' + 'an object. \n\nnew Mafuba (arg ' + 'Object) \n\nCurrently ' + typeof object);
    }

    this.data = {};
    this.refs = [];

    if (object.data) {
      if (typeof object.data === 'object' && !Array.isArray(object.data)) {
        this.data = object.data;
      } else {
        this.error('"data" node in state expects ' + 'an object as argument. \n\nnew ' + 'Mafuba({\n\tdata: node Object\n})');
      }
    } else {
      this.data = object;
    }

    if (object.mutations) {
      if (typeof object.mutations === 'object' && !Array.isArray(object.mutations)) {
        for (var mutation in object.mutations) {
          this.constructor.prototype[mutation] = object.mutations[mutation];
        }
      } else {
        this.error('"mutations" node in state expects ' + 'an object as argument. \n\nnew ' + 'Mafuba({\nmutations: node Object\n})');
      }
    }
  }

  _createClass(Mafuba, [{
    key: "error",
    value: function error(err) {
      err = err || '"setState", "dispatch" or "link" method expects an argument';
      throw new Error('[ Mafuba exception ]: ' + err);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "setState",
    value: function setState(data) {
      if (!data) this.error();
      this.data = Object.assign({}, this.data, data);
      this.refs.forEach(function (component) {
        component.forceUpdate();
      });
    }
  }, {
    key: "link",
    value: function link(component) {
      if (!component) this.error();
      this.refs.push(component);
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      if (!action) this.error();
      action.bind(this).call();
    }
  }]);

  return Mafuba;
}();

export { Mafuba as default };